<template>
  <b-row class="match-height">
    <b-col
      lg="6"
      md="12"
      sm="12"
    >
      <b-card style="background-color: rgb(255, 127, 96, 0.0); width: 100%; height: auto; border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;">
        <span style="color:#ffffff;font-size:24px; margin-left:10px">ปริมาณรถเข้าชั่งทุกสายทาง (สัปดาห์)</span>
        <!-- <div class="pie-text text-center">
          <h3 class="font-weight-bold">
            โดยรวม
          </h3>
          <h2 class="font-weight-bolder">
            {{ camTotal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}
          </h2>
        </div> -->

        <div>
          <app-echart-bar
            :option-data="optionBar"
            style="width:auto; height:350px; margin-top: 40px; margin-left: 10px;"
          />
        </div>
      </b-card>
    </b-col>
    <b-col
      lg="6"
      md="12"
      sm="12"
    >
      <b-card style="background-color: rgb(255, 127, 96, 0.0); width: 100%; height: auto; border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;">
        <span style="color:#ffffff;font-size:24px; margin-left:10px">5 Top จุดติดตั้งรถเข้าชั่งสูงสุด</span>
        <b-row
          v-for="(item, index) in progress.slice(0,5)"
          :key="index"
          style="margin-top:10px"
          class="mt-2"
        >
          <b-col
            lg="10"
          >
            <label style="color: #ffffff; font-size: 18px;">{{ index+1 +'. ' }} {{ item.StationName }}</label>
            <b-progress
              :value="item.total_vehicles"
              :max="progress[0].total_vehicles * 1.2"
              precision="2"
              class="progress8"
            />
          </b-col>
          <b-col
            lg="2"
            style="text-align: left;"
          >
            <br>
            <span style="color:#ffffff; ">{{ item.total_vehicles }} คัน</span>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BProgress, BCard,
} from 'bootstrap-vue'
import axios from '@axios'
import AppEchartBar from '@core/components/charts/echart/AppEchartBarCounting.vue'
import * as echarts from 'echarts'

export default {
  components: {
    BRow,
    BCol,
    AppEchartBar,
    BProgress,
    BCard,
  },
  data() {
    return {
      progress: [],
      camTotal: '',
      optionBar: {
        xAxisData: [],
        series: [
          {
            name: 'ทั้งหมด',
            type: 'bar',
            stack: 'Total',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: '#99FBCA',
              },
              {
                offset: 1,
                color: '#00B058',
              },
              ]),
              barBorderRadius: [4, 4, 0, 0],
            },
            data: [],
            barMaxWidth: '40%',
            barMinWidth: '10px',
          },
        ],
      },
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  computed: {

  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.getSumCCTV()
    this.getBarData()
    this.getTop5()
    this.interval = setInterval(() => {
      this.getSumCCTV()
      this.getBarData()
      this.getTop5()
    }, 300000)
  },
  methods: {
    getSumCCTV() {
      axios
        .post('/getSumCCTVTotal', { department: this.userData.department, username: this.userData.username })
        .then(response => {
          this.total = response.data[0].Total
          this.online = response.data[0].Online
          this.offline = response.data[0].Offline
        })
        .catch(error => {
          console.log(error)
        })
    },
    getBarData() {
      axios
        .post('https://wts.drr.go.th/node-red/week-WIM-Total', { department: this.userData.department, owner: this.userData.groupname, username: this.userData.username })
        .then(response => {
          this.xAxisData = []
          this.optionBar.xAxisData.splice(0)
          this.optionBar.series[0].data.splice(0)
          this.xAxisData = response.data
          this.xAxisData.forEach(value => {
            this.optionBar.xAxisData.push(value.Date_Name)
            this.optionBar.series[0].data.push(value.total_vehicles)
          })
        })
        .catch(error => {
          console.log(error)
        })
    },
    getTop5() {
      axios
        .post('https://wts.drr.go.th/node-red/top5-WIM-Total', { department: this.userData.department, username: this.userData.username })
        .then(response => {
          // eslint-disable-next-line prefer-destructuring
          this.progress = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style lang="scss">
  // .pie-text{
  //     width: 200px;
  //     position:absolute;
  //     margin: auto;
  //     left: 0;
  //     right: 0;
  //     top: 45%;
  //     bottom: 0;
  //   }

  .progress8 .progress-bar{background: linear-gradient(90deg, #00B058 46.03%, #99FBCA 100%)}

.br {
      display: block;
      margin-bottom: 0em;
    }
  </style>
